import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'TEACHER_CREDS_POST',
  POST_SUCCESS: 'TEACHER_CREDS_POST_SUCCESS',
  POST_FAILURE: 'TEACHER_CREDS_POST_FAILURE',

  PATCH: 'TEACHER_CREDS_PATCH',
  PATCH_SUCCESS: 'TEACHER_CREDS_PATCH_SUCCESS',
  PATCH_FAILURE: 'TEACHER_CREDS_PATCH_FAILURE',
};

export const patch = actions.patch(
  teacherCredId => `${BASE_URL}/teachers/teacher-cred/${teacherCredId}`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const post = actions.post(() => `${BASE_URL}/teachers/teacher-cred/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
